export function actionSetDownloadingLeadsStatuses(value) {
    return {
        type: 'SET_DOWNLOADING_LEADS_STATUSES',
        value: value,
    };
}

export function  actionSetDownloadingLeadsStatusesFetch(value) {
    return {
        type: 'SET_DOWNLOADING_LEADS_STATUSES_FETCH',
        value: value,
    };
}

export function actionSetDownloadingReportSummary(value) {
    return {
        type: 'SET_DOWNLOADING_REPORT_SUMMARY',
        value: value
    };
}

export function actionSetDownloadingReportConversion(value) {
    return {
        type: 'SET_DOWNLOADING_REPORT_CONVERSION',
        value: value
    };
}

export function actionSetDownloadingLeads(value) {
    return {
        type: 'SET_DOWNLOADING_LEADS',
        value: value
    };
}

export function actionSetDownloadingJournal(value) {
    return {
        type: 'SET_DOWNLOADING_JOURNAL',
        value: value
    };
}
